var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticClass:"justify-content-between",attrs:{"toggleable":"lg","fixed":"top","variant":"transparent"}},[_c('b-nav',[_c('router-link',{attrs:{"to":{name: 'home'}}},[_c('b-button',{attrs:{"variant":"light"}},[_vm._v("ย้อนกลับ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }